// removed by extract-text-webpack-plugin
module.exports = {"About":"About__About__1fxsG","Content":"About__Content__3km5S"};


//////////////////
// WEBPACK FOOTER
// ./src/components/About/About.css
// module id = 192
// module chunks = 0